/**
 * Created by liux on 17/9/22.
 */

import Vuex from 'vuex';
import Vue from 'vue';
import {parse, realType, extend} from '../helper/utils'
import appInfo from '../helper/getAppInfo'

/**
 *
 * @param options
 * @returns {Store<any>}
 */
export default function(options = {}) {
  Vue.use(Vuex);
  var store =  new Vuex.Store({
    state: Object.assign({
      pageTitle: '',
      loginState: true,
      appReady: true,
      appInfo: {
        app: true,
        language: '',
        macId: '',
        os: '',
        osVersion: '',
        softVersion: '',
      },
      ajaxState: {
        show: true,
        flag: 0,
        tip: '',
      },
      pageTranSet: {
        popState: false,
        popGesture: false,
        transitionType: 'fade',
        transitionMode: 'out-in',
      },
    }, options.state),
    mutations: Object.assign({
      ajaxState(state, payload) {
        Object.assign(state.ajaxState, payload);
      },
      pageTranSet(state, payload) {
        Object.assign(state.pageTranSet, payload);
      },
      loginState(state, {loginState}) {
        state.loginState = loginState;
      },
      appReady(state, {appReady}) {
        state.appReady = appReady;
      },
      pageTitle(state, {pageTitle}) {
        state.pageTitle = pageTitle;
      },
      appInfo(state, payload) {
        Object.assign(state.appInfo, payload);
      },
    }, options.mutations),
    getters: Object.assign({}, options.getters),
    actions: Object.assign({}, options.actions),
    plugins: [].concat(options.plugins||[]),
    modules: Object.assign({},options.modules),
    strict: false,
  });
  let initStore = parse(decodeURIComponent(decodeURIComponent(window.xyInitData)));

  if(realType(initStore) === 'object'){
    store.replaceState(extend({},store.state,initStore))
  }

  return store
}
